import {
  ActionAddMinerChangeLog,
  ActionBaseMinerChangeLogs,
  ActionSetMinerChangeLogs,
  ActionTypesMinerChangeLogs,
  IMinerLog,
} from "./actionsTypes";

interface IState {
  logs: IMinerLog[];
}

const initialState: IState = {
  logs: [],
};

export default function reducer(
  state = initialState,
  action: ActionBaseMinerChangeLogs
): IState {
  switch (action.type) {
    case ActionTypesMinerChangeLogs.SET_MINER_LOGS:
      return {
        ...state,
        logs: (action as ActionSetMinerChangeLogs).payload,
      };
    case ActionTypesMinerChangeLogs.CLEAR_MINER_LOGS:
      return {
        ...state,
        logs: [],
      };
    case ActionTypesMinerChangeLogs.ADD_MINER_LOG:
      const added = (action as ActionAddMinerChangeLog).payload;
      return {
        ...state,
        logs: [...state.logs, added],
      };

    default:
      return state;
  }
}
